<template>
  <div>
    <div class="row">
    <OfficeChartReceivedAll :lgSize="6" :lgOffset="0"></OfficeChartReceivedAll>
    <OfficeChartShippedAll :lgSize="6" :lgOffset="0"></OfficeChartShippedAll>
  </div>

    <div class="row" v-for="(item, index) in fnsOffices">
      <OfficeChartReceived :officeName="item.name" :lgSize="6" :lgOffset="0"></OfficeChartReceived>
      <OfficeChartShipped :officeName="item.name" :lgSize="6" :lgOffset="0"></OfficeChartShipped>
    </div>
  </div>
</template>

<script>
import OfficeChartReceived from "../../components/OfficeChartReceived";
import OfficeChartShipped from "../../components/OfficeChartShipped";
import OfficeChartReceivedAll from "../../components/OfficeChartReceivedAll";
import OfficeChartShippedAll from "../../components/OfficeChartShippedAll";
import router from "../../router";
import { allowedPath } from "../../shared/utils";
export default {
  name: "dashboard",
  components: {
    OfficeChartReceived,
    OfficeChartShipped,
    OfficeChartReceivedAll,
    OfficeChartShippedAll
  },
  data: function() {
    return {
      details: false,
      fnsOffices: []
    };
  },
  methods: {
    fetchData() {
      this.loadingData = true;
      this.$http.get("api/fns/charts/fnsOffices.php", {}).then(
        res => {
          this.loadingData = false;
          this.fnsOffices = res.data;
        },
        err => {
          this.loadingData = false;
        }
      );
    }
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
